import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { bookmarkIcon, folderIcon, noFolderIcon } from "../../constants/icons";
import CollectionBox from "../collectionBox";

function BookmarkModal({ showModal, onModalClose, setActiveTab }) {
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [activeIndex, setActiveIndex] = useState(-1);

    const [loading, setLoading] = useState(false);

    const collectionsData = [
        { title: "Algebra 2024", papers: 3, icon: <>{folderIcon}</> },
        { title: "English 2024", papers: 10, icon: <>{folderIcon}</> },
        { title: "Literature 2021", papers: 4, icon: <>{folderIcon}</> },
        { title: "Home Economics 2023", papers: 6, icon: <>{folderIcon}</> },
    ];


    const handleCreateNewCollection = () => {
        onModalClose(false);
        setShowCreateModal(true);
    };

    const handleSaveCollection = () => {
        if (searchQuery.trim()) {
            setLoading(true);
            setTimeout(() => {
                setLoading(false);
                setShowCreateModal(false);
                setActiveTab("bookmarked");
            }, 2000);
        }
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);

        if (!value.trim()) {
            setActiveIndex(-1);
        }
    };

    return (
        <>
            <Modal className="common-modal" show={showModal} onHide={() => onModalClose(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="bookmark-title">{bookmarkIcon}<span>Add bookmarked papers to a collection</span></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="bookmark-block-info">
                        <div className="circle-wrap">
                            {noFolderIcon}
                        </div>
                        <p>
                            It looks like you don’t have any collection yet. Click on
                            ‘Create New Collection’ button to get started.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => onModalClose(false)} className="btn-brown">
                        Skip
                    </Button>
                    <Button variant="primary" onClick={handleCreateNewCollection}>
                        Create New Collection
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="common-modal" show={showCreateModal} onHide={() => setShowCreateModal(false)} centered >
                <Modal.Header closeButton>
                    <Modal.Title className="bookmark-title">{folderIcon}<span>Create a new collection</span></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="collectionName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter a name of a collection"
                                value={searchQuery}
                                onChange={handleInputChange}
                            />
                        </Form.Group>

                        <div className="collection-wrapper">
                            <CollectionBox
                                collections={collectionsData}
                                onSelect={(title, index) => {
                                    setSearchQuery(title);
                                    setActiveIndex(index);
                                }}
                                searchQuery={searchQuery}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="btn-brown"
                        variant="secondary"
                        onClick={() => setShowCreateModal(false)}
                    >
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSaveCollection} disabled={!searchQuery.trim()} className="save-btn">
                        {loading ? (
                            <div className="d-flex align-items-center gap-2">
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Saving...
                            </div>
                        ) : (
                            'Save Collection'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default BookmarkModal;
